module.exports = __webpack_public_path__ + "img/appIcon-menu--Components.90d50e46.svg";